// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router';
import './Button.module.scss';
// =========================
type Color = 'blue-gray' | 'inactive' | 'black';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  to?: string;
  color?: Color;
  children: React.ReactNode;
  inactive?: boolean;
};

export default function Button({
  color = 'black',
  children,
  onClick,
  to,
  inactive,
}: Props) {
  const history = useHistory();

  return (
    <motion.button
      whileHover={{ scale: 1.03 }}
      initial={{ scale: 1 }}
      whileTap={{ scale: 0.97 }}
      onClick={
        to
          ? (e) => {
              e.stopPropagation();
              history.push(to);
            }
          : onClick
      }
      type={to ? 'button' : 'submit'}
      styleName={`Button ${color}`}
      style={
        inactive
          ? {
              pointerEvents: 'none',
              opacity: 0.5,
            }
          : {}
      }
    >
      {children}
    </motion.button>
  );
}
